import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputDropdownComponent } from './input-dropdown.component';
import { Select } from 'primeng/select';


@NgModule({
  declarations: [
    InputDropdownComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule,
    Select
  ],
  exports: [
    InputDropdownComponent
  ]
})
export class InputDropdownModule {
}
